import React from 'react';
import { Alert, Icons, useTheme } from '@ublend-npm/aulaui-core';
import { createStyles } from './InfoAlert.styles';

type Props = {
  title: string;
  children: React.ReactNode;
  sx?: object;
};

const InfoAlert = ({ title, children, sx }: Props) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Alert
      severity="info"
      icon={<Icons.InfoOutlined sx={styles.icon} />}
      sx={{ ...styles.alert, ...sx }}
    >
      <span>
        <span style={styles.title}>{title}</span>
        <span style={styles.content}>{children}</span>
      </span>
    </Alert>
  );
};

export default InfoAlert;
